import { render } from "./IntelligentLinkageMod.vue?vue&type=template&id=1d70fd90&scoped=true"
import script from "./IntelligentLinkageMod.vue?vue&type=script&lang=js"
export * from "./IntelligentLinkageMod.vue?vue&type=script&lang=js"

import "./IntelligentLinkageMod.vue?vue&type=style&index=0&id=1d70fd90&scoped=true&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d70fd90"]])

export default __exports__